module.exports = __webpack_public_path__ + "static/img/i6_rbg1.b2225b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/index/i6_rbg1.png
// module id = n8s+
// module chunks = 0